// 261015 P5d (D14) — khối GẬP «Tình tiết nguyên tác chưa lên phim (N)» cạnh kịch bản ở ScriptReader. Không có mục ⇒ không render. Không nút (chỉ-đọc, $0 AI).
import React from 'react';
import { Collapse, Tag, Typography } from 'antd';
import { droppedEventsView, type DroppedTone } from './droppedSourceView';
import type { DroppedSourceEvent } from '../../../types/adaptation';
import { DROPPED_ANCHOR_ID } from './reviewBookView';

const { Text } = Typography;

const TAG_COLOR: Record<DroppedTone, string | undefined> = { bad: 'red', warn: 'orange', muted: undefined };

/** `defaultOpen` (261023 E3-P3a): mở sẵn khi người bấm ô «Chưa lên phim» ở Sổ duyệt. */
const DroppedSourceEventsBlock: React.FC<{ events: DroppedSourceEvent[] | null | undefined; defaultOpen?: boolean }> = ({ events, defaultOpen }) => {
  const view = droppedEventsView(events);
  if (!view) return null;
  return (
    <div id={DROPPED_ANCHOR_ID}>
    <Collapse
      size="small" ghost data-testid="dropped-source-events" style={{ marginBottom: 8 }}
      defaultActiveKey={defaultOpen ? ['dropped'] : undefined}
      items={[{
        key: 'dropped',
        label: <Text type="secondary">{view.heading}</Text>,
        children: (
          <div role="list" aria-label="Tình tiết nguyên tác chưa lên phim">
            {view.rows.map((r) => (
              <div key={r.key} role="listitem" style={{ fontSize: 13, padding: '4px 0' }}>
                <Tag bordered={false} color={TAG_COLOR[r.tone]} style={{ marginRight: 6 }}>{r.label}</Tag>
                <Text>{r.summary}</Text>
                {r.quote ? <div style={{ margin: '2px 0 0', paddingLeft: 10, borderLeft: '2px solid var(--wb-line)' }}><Text type="secondary">“{r.quote}”</Text></div> : null}
                {r.reason ? <div><Text type="secondary">{r.reason}</Text></div> : null}
              </div>
            ))}
            {view.note ? <div style={{ marginTop: 4 }}><Text type="secondary" italic>{view.note}</Text></div> : null}
          </div>
        ),
      }]}
    />
    </div>
  );
};

export default DroppedSourceEventsBlock;
